class Albums {
  constructor(url) {
    this._url = url;
    this._callbacks = [];
  }

  load(callback) {
    if (this.loaded) {
      // we already have the data,
      // we can just return immediately.
      callback(this.data);
      return;
    }

    if (!this.fetching) {
      fetch(this._url, {
        credentials: 'same-origin',
      })
        .then((response) => response.json())
        .then((data) => this.resolveCallbacks(data));
    }

    this.addCallback(callback);
  }

  get data() {
    return this._data || [];
  }

  set data(data) {
    this._data = data;
  }

  get loaded() {
    return !!this._data;
  }

  get fetching() {
    return this._callbacks.length > 0;
  }

  addCallback(callback) {
    this._callbacks.push(callback);
  }

  resolveCallbacks(data) {
    this.data = data;

    this._callbacks
      .filter((callback) => typeof callback === 'function')
      .forEach((callback) => callback(data));

    this._callbacks = [];
  }
}


export default new Albums('/account/albums.json');
